import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addConnection, getConnections, getNeighbors, removeConnection } from "../firebase/controller/community";
import { isEmpty } from "lodash";
import { useEffect } from "react";
import { useContext } from "react";
import { getAuth } from "firebase/auth";

const ConnectionContext = React.createContext();

export function useConnection() {
    return useContext(ConnectionContext);
}

export function ConnectionProvider({ children }) {

    const { user } = useSelector((state) => state.authStore);
    const [loading, setLoading] = useState(false);
    const [connections, setConnections] = useState([]);
    const [done, setDone] = useState(false);
    const [ lastConnection, setLastConnection ] = useState();
    const [neighbors, setNeighbors ] = useState([]);
    const [lastNeigbour, setLastNeigbour ] = useState();


    const getconnections = async () => {
        try {
            setLoading(true);
            const res = await getConnections(lastConnection);
            setConnections(res);
            setLastConnection(res[res.length - 1])
            setLoading(false);
        } catch (error) {
            const message = error.message;
            toast.error(message);
            setLoading(false);
        }
    };
    
    
    const getneighbors = async () => {
        try {
            setLoading(true);
            const res = await getNeighbors(lastNeigbour, connections);
            setNeighbors(res);
            setLastNeigbour(res[res.length - 1])
            setLoading(false);
        } catch (error) {
            const message = error.message;
            toast.error(message);
            setLoading(false);
        }
    };


    const listNextNeighbors = async () => {
        try {
            if (!isEmpty(user)) {
                setLoading(true);
                const res = await getNeighbors(lastConnection, connections);
                setNeighbors([...neighbors, ...res]);
                setLoading(false);
            }
        } catch (error) {
            const message = error.message;
            toast.error(message);
            setLoading(false);
        }
    };


    const listNextConnections = async () => {
        try {
            if (!isEmpty(user)) {
                setLoading(true);
                const res = await getConnections(lastConnection);
                setConnections([...connections, ...res]);
                setLastConnection(res[res.length - 1])
                setLoading(false);
            }
        } catch (error) {
            const message = error.message;
            toast.error(message);
            setLoading(false);
        }
    };


    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged((user) => {
            if (user) {
                getconnections();
                getneighbors();
            }
        });
        return unsubscribe;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const disconnect = async (connectionId) => {
        try {
            setLoading(true);
            const res = await removeConnection(connectionId);
            res && toast.success("Connection removed successfully.");
            setLoading(false);
            setDone(true);
        } catch (error) {
            const message = error.message;
            toast.error(message);
            setLoading(false);
        }
    }

    const connect = async (userId) => {
        try {
            setLoading(true);
            const res = await addConnection(userId);
            res && toast.success("Connection added successfully.");
            setNeighbors(neighbors.filter((ne) => ne?.id !== userId))
            setLoading(false);
            setDone(true);
        } catch (error) {
            const message = error.message;
            toast.error(message);
            console.log(message)
            setLoading(false);
        }
    }

    const value = {
        loading,
        setLoading,
        done, 
        neighbors,
        setDone,
        connections,
        disconnect,
        listNextConnections,
        listNextNeighbors,
        connect
    };

    return <ConnectionContext.Provider value={value}>{children}</ConnectionContext.Provider>;
}